import { useEffect, useState } from 'react'
import { getSettings } from '@/services/settings'
import { parseConfiguredInboxes } from '@/utils/inboxFilter'

export function useMonitoredInboxes(): string[] {
  const [inboxes, setInboxes] = useState<string[]>([])

  useEffect(() => {
    let cancelled = false
    void getSettings()
      .then(({ settings }) => {
        if (cancelled) return
        setInboxes(parseConfiguredInboxes(settings.user_emails?.value ?? ''))
      })
      .catch(() => {
        if (!cancelled) setInboxes([])
      })
    return () => {
      cancelled = true
    }
  }, [])

  return inboxes
}
